// AudioPlayer.js - MODIFICADO COM VARIÁVEIS DE TEMA

import React from 'react';
import AudioPlayerH5 from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

const formatTime = (seconds) => {
  if (isNaN(seconds)) return '00:00';
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
};

export default function AudioPlayer({ src, transcription }) {
  if (!src) return null;
  return (
    <div className="audio-player-chat-container">
      <AudioPlayerH5
        src={src}
        showJumpControls={false}
        customAdditionalControls={[]}
        customVolumeControls={[]}
        layout="horizontal"
        formatTime={formatTime}
        style={{
          borderRadius: 12,
          minHeight: 48,
          fontFamily: 'Inter, Arial, sans-serif',
          width: '100%',
        }}
      />
      {transcription && (
        // As cores fixas aqui foram substituídas por nossas variáveis CSS
        <p style={{
          fontSize: '0.9em',
          color: 'var(--theme-audio-transcription-foreground, #555)', /* MODIFICADO */
          fontStyle: 'italic',
          margin: '8px 0 0 0',
          paddingTop: 8,
          borderTop: '1px solid var(--theme-border-color, #eee)' /* MODIFICADO */
        }}>
          {transcription}
        </p>
      )}
    </div>
  );
}